import { ApolloClient, ApolloError } from "@apollo/client"
import { CHECK_FILE_NAME } from "../../queries/CHECK_FILE_NAME"

export const checkFileName = async (
    name: string | undefined,
    client: ApolloClient<object>
): Promise<boolean> => {
    if (!name) return true
    const query = client
        .query({
            variables: { checkFileNameInput: { fileName: name } },
            query: CHECK_FILE_NAME,
            fetchPolicy: "network-only"
        })
        .catch((err: ApolloError) => {
            throw err
        })
    return await query.then(() => true).catch(() => false)
}
